let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4a4SV")).then(() => parcelRequire('docQr'));